/**
 * Same character / length rules as the report "Título" field (form-attribute Title).
 */
export const TITLE_TEXT_MAX_LENGTH = 150;

export const TITLE_TEXT_CHAR =
  /^[a-zA-Z0-9áéíóúüÁÉÍÓÚÜñÑ\s\-_.',;:]$/;

export const TITLE_TEXT_VALUE =
  /^[a-zA-Z0-9áéíóúüÁÉÍÓÚÜñÑ\s\-_.',;:]*$/;

/** Paste allows a slightly wider set (matches form-attribute onPaste for Title). */
export const TITLE_TEXT_PASTE =
  /^[a-zA-Z0-9áéíóúüÁÉÍÓÚÜñÑ\s\-_@.+',;:]*$/;

export function hasInvalidTitleText(value: string | null | undefined): boolean {
  if (value == null || value === '') {
    return false;
  }
  return !TITLE_TEXT_VALUE.test(String(value));
}

export function blockTitleTextKeypress(
  event: KeyboardEvent,
  maxLength: number = TITLE_TEXT_MAX_LENGTH
): void {
  const char = event.key;
  const target = event.target as HTMLInputElement | HTMLTextAreaElement;
  const currentValue = target?.value ?? '';
  const selectionStart = target?.selectionStart ?? 0;

  if (selectionStart === 0 && char === ' ') {
    event.preventDefault();
    return;
  }

  if (
    maxLength > 0 &&
    currentValue.length >= maxLength &&
    !['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight'].includes(char)
  ) {
    event.preventDefault();
    return;
  }

  if (char.length !== 1) {
    return;
  }

  if (!TITLE_TEXT_CHAR.test(char)) {
    event.preventDefault();
  }
}

export function blockTitleTextPaste(
  event: ClipboardEvent,
  maxLength: number = TITLE_TEXT_MAX_LENGTH
): void {
  const clipboardData = event.clipboardData?.getData('text') || '';
  const target = event.target as HTMLInputElement | HTMLTextAreaElement;
  const currentValue = target?.value ?? '';

  if (
    maxLength > 0 &&
    currentValue.length + clipboardData.length > maxLength
  ) {
    event.preventDefault();
    return;
  }

  if (!TITLE_TEXT_PASTE.test(clipboardData)) {
    event.preventDefault();
  }
}
